import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

const WrappedInfo = styled.div `
  position:absolute;
  top: 50%;
  right: 50%;
  justify-content: center;
  text-align: center;
  margin: 5px;
  color:black;
  background:#FFF;
  padding:20px;
`;
const AnalyticsModeInfo = ({ item_id }) => {
  const analyticsData = useSelector(state => state.sceneGrid.analyticsData) || {};
    const analyticsMode  = useSelector(state=>state.config.analyticsMode)||{};

  if (!analyticsMode || !analyticsData) return null;
  let { impressions, clicks } = (analyticsData[item_id]) || {};
  let ratio = impressions ? (clicks / impressions * 100).toFixed(2) : "";
  if (!ratio) return null;
  return (
    ratio && <WrappedInfo>{ratio}</WrappedInfo>
  );
};

export default AnalyticsModeInfo;
